// extracted by mini-css-extract-plugin
export var cardIcon = "_8e-5";
export var cardIconUnframed = "_8e-9";
export var checkboxCard = "_8e-0";
export var checkboxCardSelected = "_8e-4";
export var disabled = "_8e-2";
export var interactive = "_8e-1";
export var outerBorder = "_8e-3";
export var spacerMedium = "_8e-8";
export var spacerSmall = "_8e-7";
export var spacerXsmall = "_8e-6";